export const AUTH_APP_RETURN_URL_QUERY = 'returnUrl';
export const RESET_PASSWORD_OTP = 'RESET_PASSWORD_OTP';
export const ACCESS_TOKEN = 'AccessToken';
export const SIGN_UP_OTP = 'signUpOTP';

// Regarding signUpDataContext
export const USER_EMAIL = 'userEmail';
export const USER_NAME = 'userName';
export const USER_COUNTRY = 'userCountry';

export const ASSET_INFO = 'assetInfo';
export const WORK_ITEM_INFO = 'workItemInfo';

// Cookie constants
export const ORG_NAME = 'OrgName';
export const IS_USER_LOGGED_IN = 'isUserLoggedIn';
export const USE_CUSTOM_TOKEN = 'useCustomToken';

// CurrentOrganizationContext
export const ORG_ID = 'orgId';
export const COUNTRY_CODE = 'countryCode';

export const NAVIGATE_BACK_TO_URL = 'navigateBackToURL';

// SearchResults return URL
export const SEARCH_RESULTS_RETURN_URL = 'searchResultsReturnUrl';

// Pending credential constants
export const PENDING_CREDENTIAL = 'pendingCredential';
export const PENDING_CREDENTIAL_EMAIL = 'pendingCredentialEmail';

// Plan related constants
export const SHOW_PLANS_DIALOG = 'showPlansDialog';

// Entitlement related constants
export const ENTITLEMENT_TOKEN = 'entitlementToken';

// Create organization flow constants
export const IS_CREATE_ORGANIZATION = 'isCreateOrganization';
export const CREATE_ORG_RETURN_URL = 'createOrgReturnUrl';

// Application shell
export const SIDEBAR_OPEN_STORAGE_KEY = 'assetron_sidebar_open';
